/**
 * Created by swandelow on 8/24/16.
 */
angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/company/:companyOid/specialoffer", {
        templateUrl: 'assets/specialoffer/index.html',
        controller: 'SpecialOffersController',
        title: 'specialOffers.TITLE',
        sidebar: 'priceAndAvailability'
    }).when("/company/:companyOid/specialoffer/discount", {
        templateUrl: 'assets/specialoffer/specialoffer.html',
        controller: 'SpecialOfferController',
        title: 'specialOffers.TITLE',
        sidebar: 'priceAndAvailability'
    }).when("/company/:companyOid/specialoffer/upgrade", {
        templateUrl: 'assets/specialoffer/specialoffer-upgrade.html',
        controller: 'SpecialOfferUpgradeController'
    }).when("/moderate", {
        templateUrl: 'assets/specialoffer/moderate.html',
        controller: 'ModerateController',
        title: 'moderate.TITLE',
        sidebar: 'moderate'
    });
}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/routes/special_offer_route.js
// module id = 821
// module chunks = 3